import './App.css';
import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./Login";
import Dashboard from "./Dashboard";
import './i18n';
import { useTranslation } from "react-i18next";

function App() {
  const [user, setUser] = useState(null);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        await firebaseUser.reload();
        setUser(firebaseUser);
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div>
      <div className="language-switcher">
        <button onClick={() => i18n.changeLanguage('en')}>EN</button>
        <button onClick={() => i18n.changeLanguage('es')}>ES</button>
      </div>
      {user ? (
        <>
          <Dashboard user={user} />
          <div className="content-wrapper button-wrapper">
            <button
              onClick={() => {
                signOut(auth);
                window.localStorage.removeItem("emailForSignIn");
                const url = new URL(window.location.href);
                url.search = "";
                window.history.replaceState({}, document.title, url.toString());
              }}
            >
              {t("signOut")}
            </button>
          </div>
        </>
      ) : (
        <Login />
      )}
    </div>
  );
}

export default App;
